import { katTranslator } from '../../shared/i18n';

const strings = {
  'kat-expander-open': {
    'ar-AE': 'توسيع',
    'bn-IN': 'প্রসারিত করুন',
    'cs-CZ': 'rozbalit',
    'da-DK': 'udvid',
    'de-DE': 'erweitern',
    'en-US': 'expand',
    'es-ES': 'desplegar',
    'es-MX': 'expandir',
    'es-US': 'expandir',
    'fr-BE': 'développer',
    'fr-CA': 'développer',
    'fr-FR': 'développer',
    'he-IL': 'הרחבה',
    'hi-IN': 'और दिखाएं',
    'it-IT': 'espandi',
    'ja-JP': '展開',
    'kn-IN': 'ವಿಸ್ತರಿಸಿ',
    'ko-KR': '확장',
    'ml-IN': 'വിപുലീകരിക്കുക',
    'mr-IN': 'विस्तार करा',
    'nl-BE': 'uitklappen',
    'nl-NL': 'uitvouwen',
    'pl-PL': 'rozwiń',
    'pt-BR': 'expandir',
    'pt-PT': 'expandir',
    'sv-SE': 'utöka',
    'ta-IN': 'விரிவாக்கு',
    'te-IN': 'విస్తరించండి',
    'tr-TR': 'Genişlet',
    'zh-CN': '展开',
    'zh-TW': '展開',
  },
  'kat-expander-close': {
    'ar-AE': 'طي',
    'bn-IN': 'সংকুচিত করুন',
    'cs-CZ': 'sbalit',
    'da-DK': 'skjul',
    'de-DE': 'minimieren',
    'en-US': 'collapse',
    'es-CL': 'contraer',
    'es-CO': 'contraer',
    'es-ES': 'contraer',
    'es-MX': 'contraer',
    'es-US': 'minimizar',
    'fr-BE': 'réduire',
    'fr-CA': 'réduire',
    'fr-FR': 'réduire',
    'he-IL': 'צמצום',
    'hi-IN': 'कम दिखाएं',
    'it-IT': 'comprimi',
    'ja-JP': '部分表示',
    'kn-IN': 'ಕುಗ್ಗಿಸಿ',
    'ko-KR': '축소',
    'ml-IN': 'ചുരുക്കുക',
    'mr-IN': 'संकुचित करा',
    'nl-BE': 'inklappen',
    'nl-NL': 'samenvouwen',
    'pl-PL': 'zwiń',
    'pt-BR': 'recolher',
    'pt-PT': 'fechar',
    'sv-SE': 'minimera',
    'ta-IN': 'சுருக்கு',
    'te-IN': 'కుదించండి',
    'tr-TR': 'Daralt',
    'zh-CN': '折叠',
    'zh-TW': '收合',
  },
};

export default katTranslator(strings);
